module.exports = __webpack_public_path__ + "static/media/up.fbe135d6.svg";